import popup from '@utils/popup.js'
import { API_SESSION_CHECK, API_LOGOUT } from '@utils/api.js'
import store from '@state/store'
import $ from '@utils/axios.js'
import axios from 'axios'

export const state = {
  loggedIn: false,
  sessionId: getSavedState('sessionId'),
  // userType: getSavedState('userType'),
  userType: 99,
  appType: getSavedState('appType'),
  memberNo: '',
}

export const mutations = {
  SET_SESSION_ID(state, newValue) {
    state.sessionId = newValue
    saveState('sessionId', newValue)
  },
  SET_USER_TYPE(state, newValue) {
    state.userType = newValue
    saveState('userType', newValue)
  },
  SET_APP_TYPE(state, newValue) {
    state.appType = newValue
    saveState('appType', newValue)
  },
  SET_MEMBER_NO(state, newValue) {
    state.memberNo = newValue
  },
  SET_LOGGEDIN(state, newValue) {
    state.loggedIn = newValue
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  // init({ state, dispatch }) {
  //   dispatch('validate')
  // },

  simpleLogin({ commit, dispatch, getters }) {
    commit('SET_LOGGEDIN', true)
    commit('SET_USER_TYPE', 0)
  },
  linksLogin({ commit, dispatch, getters }) {
    commit('SET_LOGGEDIN', true)
    commit('SET_USER_TYPE', 80)
  },
  logout({ commit, dispatch, getters }) {
    window.localStorage.removeItem('SsnId')
    window.localStorage.removeItem('sessionId')
    commit('SET_LOGGEDIN', false)
    commit('SET_USER_TYPE', 99)
  },
  logoutReload({ commit, dispatch, getters }) {
    return new Promise((resolve, reject) => {
      const params = {}
      params.session_id = getSavedState('sessionId')

      var formData = new FormData();
      for (var k in params) {
        formData.append(k, params[k] ?? "");
      }

      $.post(API_LOGOUT, formData)
        .then((response) => {
          var statusCode = response.data.status_code
          if (statusCode === '00') {
            window.localStorage.removeItem('SsnId')
            window.localStorage.removeItem('sessionId')
            const pattern = new RegExp('(SsnId=([^&]*))(&)*', 'g')
            const url = location.href.replace(pattern, '')
            window.location.replace(url)
            commit('SET_USER_TYPE', 99)
            return resolve()
          } else {
            window.localStorage.removeItem('SsnId')
            window.localStorage.removeItem('sessionId')
            const pattern = new RegExp('(SsnId=([^&]*))(&)*', 'g')
            const url = location.href.replace(pattern, '')
            window.location.replace(url)
            commit('SET_USER_TYPE', 99)
            return reject(response)
          }
        })
        .catch((e) => {
          store.dispatch('layout/endLoading')
          return reject(e)
        })
    })
  },
  // Logs in the current user.
  logIn({ commit, dispatch, getters }) {
    return new Promise((resolve, reject) => {
      // store.dispatch('layout/startLoading')
      window.localStorage.removeItem('error')
      var ssnId = null
      if (window.localStorage.getItem('SsnId')) {
        ssnId = window.localStorage.getItem('SsnId')
      }
      if (ssnId) {
        const params = {}
        params.SSO_SESSION_ID = ssnId

        var formData = new FormData();
        for (var k in params) {
          formData.append(k, params[k] ?? "");
        }

        axios
          .post(API_SESSION_CHECK, formData)
          .then((response) => {
            var statusCode = response.data.status_code
            if (statusCode === '00') {
              // console.log('TODO: APIOK')
              commit('SET_SESSION_ID', response.data.session_id)
              // commit('SET_USER_TYPE', postData.User_type)
              // commit('SET_APP_TYPE', postData.App_type)
              commit('SET_MEMBER_NO', params.member_no)
              // store.dispatch('layout/endLoading')
              store.dispatch('auth/simpleLogin')
              if (window.sessionStorage.getItem('iframemode')) {
                if (window.sessionStorage.getItem('iframemode') === '1') {
                  store.dispatch('auth/linksLogin')
                }
              }
              return resolve()
            } else {
              commit('SET_SESSION_ID', '')
              commit('SET_USER_TYPE', '')
              commit('SET_APP_TYPE', '')
              commit('SET_MEMBER_NO', '')
              store.dispatch('auth/logout')
              // console.log('TODO: APIエラー')
              // store.dispatch('layout/endLoading')
              window.location.reload()
              return reject(response)
            }
          })
          .catch((e) => {
            commit('SET_SESSION_ID', '')
            commit('SET_USER_TYPE', '')
            commit('SET_APP_TYPE', '')
            commit('SET_MEMBER_NO', '')
            store.dispatch('auth/logout')
            window.location.reload()
            // console.log('TODO: アクセスエラー')
            store.dispatch('layout/endLoading')
            return reject(e)
          })
      } else {
        store.dispatch('auth/logout')
        const params = {}
        params.GUEST_MODE = '1'
        params.SSO_SESSION_ID = getSavedState('sessionId')

        var formData = new FormData();
        for (var k in params) {
          formData.append(k, params[k] ?? "");
        }

        $.post(API_SESSION_CHECK, formData)
          .then((response) => {
            var statusCode = response.data.status_code
            if (statusCode === '00') {
              // console.log('TODO: APIOK')
              commit('SET_SESSION_ID', response.data.session_id)
              // commit('SET_USER_TYPE', postData.User_type)
              // commit('SET_APP_TYPE', postData.App_type)
              commit('SET_MEMBER_NO', params.member_no)
              // store.dispatch('layout/endLoading')
              if (window.sessionStorage.getItem('iframemode')) {
                if (window.sessionStorage.getItem('iframemode') === '1') {
                  store.dispatch('auth/linksLogin')
                }
              }
              return resolve()
            } else {
              commit('SET_SESSION_ID', '')
              commit('SET_USER_TYPE', '')
              commit('SET_APP_TYPE', '')
              commit('SET_MEMBER_NO', '')
              // console.log('TODO: APIエラー')
              // store.dispatch('layout/endLoading')
              return reject(response)
            }
          })
          .catch((e) => {
            // console.log('TODO: アクセスエラー')
            store.dispatch('layout/endLoading')
            return reject(e)
          })

        // store.dispatch('layout/endLoading')
        // console.log('TODO: session未確認')
        // return resolve()
      }
    })
  },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
 //  if (process.env.NODE_ENV === 'development' && process.env[`VUE_APP_${key}`]) {
 //   return process.env[`VUE_APP_${key}`]
 // }

  var item = window.localStorage.getItem(key)
  if (!item) {
    return ''
  } else {
    try {
      return JSON.parse(item)
    } catch (e) {
      return ''
    }
  }
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}
